export const SET_INITIAL_LOAD = "SET_INITIAL_LOAD";
export const SET_FIRST_VISIT_OF_THE_DAY = "SET_FIRST_VISIT_OF_THE_DAY";
